import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'distributedItcDetails',
  props: ['rowData', 'isdRecipientGstn'],
  watch: {
    currentPage: function() {
      this.getIsdCreditDistributionDetails();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getIsdCreditDistributionDetails();
    }
  },
  data() {
    return {
      loader: false,
      perPage: commonHelper.perPageRecord,
      currentPage: 1,
      totalRows: null,
      pageOptions: commonHelper.getPageOption(),
      downloadPayload: null,
      distributedItcDetailsData: [],
      distributedItcDetailsFields: [
        {
          key: 'RecipientGstn',
          label: 'Recipient GSTN',
          class: 'text-center'
        },
        {
          key: 'OperatingUnit',
          label: 'Operating Unit',
          class: 'text-center'
        },
        {
          key: 'DocumentNum',
          label: 'Document Number',
          class: 'text-center'
        },

        {
          key: 'InvoiceNum',
          label: 'Invoice Number',
          class: 'text-center'
        },
        {
          key: 'TaxInvoiceNum',
          label: 'Tax Invoice Number',
          class: 'text-center'
        },
        {
          key: 'IsdGstn',
          label: 'ISD GSTN',
          class: 'text-center'
        },
        {
          key: 'TpGst',
          label: 'TP GST',
          class: 'text-center'
        },
        {
          key: 'VendorName',
          label: 'Vendor Name',
          class: 'text-center'
        },
        {
          key: 'InvoiceDate',
          label: 'Invoice Date',
          class: 'text-center'
        },
        {
          key: 'GlDate',
          label: 'GL Date',
          class: 'text-center'
        },
        {
          key: 'InvoiceAmount',
          label: 'Invoice Amount',
          class: 'text-center'
        },
        {
          key: 'TaxableAmount',
          label: 'Taxable Amount',
          class: 'text-center'
        },
        {
          key: 'RecInputCgst',
          label: 'CGST-R',
          class: 'text-center',
          variant: 'success'
        },
        {
          key: 'RecInputSgst',
          label: 'SGST-R',
          class: 'text-center',
          variant: 'success'
        },
        {
          key: 'RecInputIgst',
          label: 'IGST-R',
          class: 'text-center',
          variant: 'success'
        },
        {
          key: 'NonrecInputCgst',
          label: 'CGST-NR',
          class: 'text-center',
          variant: 'danger'
        },
        {
          key: 'NonrecInputSgst',
          label: 'SGST-NR',
          class: 'text-center',
          variant: 'danger'
        },
        {
          key: 'NonrecInputIgst',
          label: 'IGST-NR',
          class: 'text-center',
          variant: 'danger'
        },

        {
          key: 'RecDistCgst',
          label: 'CGST-R',
          class: 'text-center',
          variant: 'success'
        },
        {
          key: 'RecDistSgst',
          label: 'SGST-R',
          class: 'text-center',
          variant: 'success'
        },
        {
          key: 'RecDistIgst',
          label: 'IGST-R',
          class: 'text-center',
          variant: 'success'
        },
        {
          key: 'NonrecDistCgst',
          label: 'CGST-NR',
          class: 'text-center',
          variant: 'danger'
        },
        {
          key: 'NonrecDistSgst',
          label: 'SGST-NR',
          class: 'text-center',
          variant: 'danger'
        },
        {
          key: 'NonrecDistIgst',
          label: 'IGST-NR',
          class: 'text-center',
          variant: 'danger'
        },
        {
          key: 'OriginalTaxType',
          label: 'Original Tax Type',
          class: 'text-center'
        },
        {
          key: 'FinalTaxType',
          label: 'Final Tax Type',
          class: 'text-center'
        },

        {
          key: 'TaxRatePercentage',
          label: 'Tax Rate Percentage',
          class: 'text-center'
        },
        {
          key: 'SacCode',
          label: 'SAC CODE',
          class: 'text-center'
        },
        {
          key: 'RevCharge',
          label: 'Reverse Charge',
          class: 'text-center'
        }
      ]
    };
  },
  mounted() {
    this.getIsdCreditDistributionDetails();
  },

  methods: {
    getIsdCreditDistributionDetails() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        le_id: this.rowData.LeId,
        fp_gst: this.rowData.IsdGstn,
        dist_period: this.rowData.DistPeriodName,
        fin_year: this.rowData.FinYear,
        recipient_gstn: this.isdRecipientGstn
      };
      this.downloadPayload = payload;
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdCreditDistributionDetails', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.distributedItcDetailsData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
            // this.distributedItcDetailsData.map(data => {
            //   data.RevCharge = data.RevCharge === 'Y' ? true : false;
            //   return data;
            // });
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    downloadItcData() {
      this.loader = true;
      const downloadpayload = { ...this.downloadPayload };
      downloadpayload._limit = this.totalRows;
      this.downloadExcel.downloadData(
        downloadpayload,
        'isdRevenue/getIsdCreditDistributionDetails',
        'Distribution Details',
        () => (this.loader = false)
      );
    },
     downloadUnReconcileData() {
      this.loader = true;
      const downloadpayload = { ...this.downloadPayload };
      downloadpayload._limit = this.totalRows;
      this.downloadExcel.downloadData(
        downloadpayload,
        'isdRevenue/getIsdUnReconcileData',
        'Distribution Details',
        () => (this.loader = false)
      );
    },
     downloadReconcileData() {
      this.loader = true;
      const downloadpayload = { ...this.downloadPayload };
      downloadpayload._limit = this.totalRows;
      this.downloadExcel.downloadData(
        downloadpayload,
        'isdRevenue/getIsdReconcileData',
        'Distribution Details',
        () => (this.loader = false)
      );
    }
  }
};
